import { OwnableTheme } from '@Theme';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';

import { HamburgerAnimation } from './HamburgerAnimation';
import { useHamburgerButtonPresenter } from './HamburgerButton.presenter';

const StyledAnimationContainer = styled.View`
  width: 20px;
  height: 10px;
`;

type IProps = {
  color?: string;
};

const HamburgerButtonPressable: FC<IProps> = ({
  color = OwnableTheme.colors.persianIndigo,
}) => {
  const { onPress, isOpen } = useHamburgerButtonPresenter();

  return (
    <Pressable onPress={onPress}>
      <StyledAnimationContainer>
        <HamburgerAnimation
          isOpen={isOpen.value}
          width={20}
          height={10}
          color={color}
        />
      </StyledAnimationContainer>
    </Pressable>
  );
};

export default observer(HamburgerButtonPressable);
